import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Box,  CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import '../css/PostedWinners.css';

const PostedWinners = () => {

    const [winners, setWinners] = useState([]);
      const [loading, setLoading] = useState(true);
      const navigate = useNavigate();
      useEffect(() => {
        const fetchwinners = async () => {
          try {
            const res = await axios.get('/api/postedwinners');
            setWinners(res.data);
            setLoading(false);
          } catch (error) {
            console.error("Error fetching winners:", error);
            setLoading(false);
          }
        };
    
        fetchwinners();
      }, []);
    
      if (loading) return <CircularProgress />;
    

    return (
    <Box p={3}>
     <div className='ptwincontentCard' >
            <div className='ptwincardHeader'>
              <h3 className='ptwincardTitle'>KSE Winners List</h3>
              <button style={{ backgroundColor: '#059669'}}
              onClick={() => navigate('/dashboard/winners/addwinner')}
              className='ptwinprimaryButton'
              >
                Add Winners
              </button>
            </div>
            {winners.map((winner) => (
              <div key={winner._id} className='ptwinjobCard'>
                <div className='ptwinjobInfo'>
                  {/* <img
                  src={winner.imgurl}
                  alt='winner image'
                  style={styles.winnerImage}
                  className='ptwinwinnerImage'
                  /> */}
                  <p className='ptwinjobDetails'><strong>Program Name:</strong> {winner.category}</p>
                  <p className='ptwinjobDetails'><strong>Position:</strong> {winner.position}</p>
                  <p className='ptwinjobDetails'><strong>Chest No.:</strong> {winner.chest}</p>
                  <p className='ptwinjobDetails'><strong>Name:</strong> {winner.name}</p>
                  <p className='ptwinjobDetails'><strong>School Name:</strong> {winner.school}</p>
                  <p className='ptwinjobDetails'><strong>Location:</strong> {winner.location}</p>
                  {/* <p style={styles.jobDetails}>Description: {program.description}</p> */}
                  
                </div>
                {/* <span style={styles.statusBadge}>
                  Active
                </span> */}
              </div>
            ))}
     </div>
  </Box>
    );
}

// const styles = {

//   contentCard: {
//     backgroundColor: 'white',
//     borderRadius: '8px',
//     boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
//     border: '1px solid #e5e7eb',
//     padding: '24px',
//     marginBottom: '24px'
//   },
//   cardHeader: {
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     marginBottom: '16px'
//   },
//   cardTitle: {
//     fontSize: '18px',
//     fontWeight: '600',
//     margin: 0
//   },
//   primaryButton: {
//     padding: '8px 16px',
//     backgroundColor: '#2563eb',
//     color: 'white',
//     border: 'none',
//     borderRadius: '8px',
//     cursor: 'pointer',
//     fontSize: '14px',
//     fontWeight: '500'
//   },
//     jobCard: {
//     border: '1px solid #e5e7eb',
//     borderRadius: '8px',
//     padding: '16px',
//     marginBottom: '12px',
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'flex-start'
//   },
//   jobInfo: {
//     flex: 1
//   },
//   jobTitle: {
//     fontWeight: '500',
//     margin: '0 0 4px 0'
//   },
//   jobDetails: {
//     fontSize: '14px',
//     color: '#6b7280',
//     margin: '0 0 4px 0'
//   },
//   jobMeta: {
//     fontSize: '14px',
//     color: '#9ca3af',
//     margin: 0
//   },
//   statusBadge: {
//     padding: '4px 8px',
//     backgroundColor: '#dcfce7',
//     color: '#065f46',
//     fontSize: '12px',
//     borderRadius: '9999px'
//   },
//   winnerImage: {
//     width:'150px',
//     height:'150px',
//   }
// }

export default PostedWinners;